import { generatePath } from "react-router-dom";
import { apiRoutes } from "../apiRoutes";
import axios from "../appAxios";

export const getProductReviews = async (productId, params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const response = await axios.get(
    `${generatePath(apiRoutes.GET_PRODUCT_REVIEWS, { productId })}?${qs}`,
  );
  return response.data;
};

export const getProduct = async (productId) => {
  const response = await axios.get(
    generatePath(apiRoutes.GET_PRODUCT, { productId }),
  );
  return response.data;
};

export const getProductForCreator = async (productId) => {
  const response = await axios.get(
    generatePath(apiRoutes.ADMIN_PRODUCT, { productId }),
  );
  return response.data;
};

const appendToFormData = (formData, data, fileKeys = [], parentKey = "") => {
  if (data instanceof File) {
    // Append File directly
    formData.append(parentKey, data);
  } else if (Array.isArray(data)) {
    // Handle arrays
    data.forEach((value, index) => {
      const arrayKey = fileKeys.includes(parentKey)
        ? `${parentKey}`
        : `${parentKey}[${index}]`;
      appendToFormData(formData, value, fileKeys, arrayKey); // Recursively handle array values
    });
  } else if (data && typeof data === "object") {
    // Handle nested objects
    Object.keys(data).forEach((key) => {
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;
      appendToFormData(formData, data[key], fileKeys, fullKey);
    });
  } else {
    // Append primitive values (strings, numbers, etc.)
    formData.append(parentKey, data);
  }
};

export const createProduct = async (productInfo) => {
  const formattedProductInfo = new FormData();
  appendToFormData(formattedProductInfo, productInfo, ["images"]);
  const newProduct = await axios.post(
    generatePath(apiRoutes.CREATE_PRODUCT, { shopId: productInfo.shopId }),
    formattedProductInfo,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return newProduct.data;
};

export const updateProduct = async (productInfo) => {
  const withFormattedImages = splitOldAndNewImages(productInfo);
  const formattedProductInfo = new FormData();
  appendToFormData(formattedProductInfo, withFormattedImages, [
    "updatedImages",
  ]);
  const updatedProduct = await axios.patch(
    generatePath(apiRoutes.ADMIN_PRODUCT, { productId: productInfo.id }),
    formattedProductInfo,
  );
  return updatedProduct.data;
};

const splitOldAndNewImages = (productInfo) => {
  if (productInfo.images?.length > 0) {
    const onlyNewFiles = productInfo.images.filter((image) => !image.id);
    productInfo.updatedImages = onlyNewFiles;
    productInfo.images = productInfo.images.filter((image) => !!image.id);
  }

  return productInfo;
};
